"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eHoitoVisualGroupStyle = exports.eHoitoAppointmentReservationAction = exports.eHoitoEventType = exports.eHoitoPlanType = void 0;
var eHoitoPlanType;
(function (eHoitoPlanType) {
    eHoitoPlanType["COACHING"] = "coaching";
    eHoitoPlanType["TREATMENT"] = "treatment";
})(eHoitoPlanType = exports.eHoitoPlanType || (exports.eHoitoPlanType = {}));
var eHoitoEventType;
(function (eHoitoEventType) {
    eHoitoEventType["EVENT"] = "tapahtuma";
    eHoitoEventType["INFIT"] = "infit";
    eHoitoEventType["REFERRAL"] = "l\u00E4hete";
    eHoitoEventType["APPOINTMENT"] = "ajanvaraus";
    eHoitoEventType["QUESTION"] = "kysymys";
    eHoitoEventType["DIGICLINIC_CHAT"] = "digiklinikkaChat";
    eHoitoEventType["INFO"] = "info";
    eHoitoEventType["NAVIGATION"] = "navigaatio";
    eHoitoEventType["JSON_INFO"] = "jsonInfo";
    eHoitoEventType["JSON_QUESTION"] = "jsonKysymys";
    eHoitoEventType["INFO_LINK"] = "infoLink";
    eHoitoEventType["HABIT_INTRO"] = "habitIntro";
    eHoitoEventType["HABIT_QUESTION"] = "habitQuestion";
    eHoitoEventType["QUESTION_EN"] = "question";
    eHoitoEventType["ACTION"] = "action";
    eHoitoEventType["SURVEY"] = "survey";
    eHoitoEventType["MEASUREMENT_PERIOD"] = "mittausjakso";
})(eHoitoEventType = exports.eHoitoEventType || (exports.eHoitoEventType = {}));
var eHoitoAppointmentReservationAction;
(function (eHoitoAppointmentReservationAction) {
    eHoitoAppointmentReservationAction["CALL"] = "call";
    eHoitoAppointmentReservationAction["NOT_MANDATORY"] = "not-mandatory";
    eHoitoAppointmentReservationAction["RESERVE"] = "reserve";
    eHoitoAppointmentReservationAction["ALREADY_RESERVED"] = "already-reserved";
})(eHoitoAppointmentReservationAction = exports.eHoitoAppointmentReservationAction || (exports.eHoitoAppointmentReservationAction = {}));
var eHoitoVisualGroupStyle;
(function (eHoitoVisualGroupStyle) {
    eHoitoVisualGroupStyle["INLINE"] = "inline";
    eHoitoVisualGroupStyle["NAVIGATION"] = "navigation";
    eHoitoVisualGroupStyle["EMBED_BOX"] = "embedBox";
    eHoitoVisualGroupStyle["EXPANDER_EMBED_BOX"] = "expanderEmbedBox";
    eHoitoVisualGroupStyle["EMBED_BOX_COMMENT"] = "embedBoxComment";
})(eHoitoVisualGroupStyle = exports.eHoitoVisualGroupStyle || (exports.eHoitoVisualGroupStyle = {}));
